import './styles/global.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initPreferences } from '@/features/settings';

import { App } from './app/App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

// Theme and text size go onto <html> before the first paint, so the page never flashes.
initPreferences();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
